// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"108":"f35af2d686b5d2c1","253":"a362ef4b3a56f7b4","842":"c6e2652fd25a857f","954":"d664f0aa62595312"}[chunkId] + ".js";
};